export default __webpack_public_path__ + "static/media/redux.b6fa52e8.png";